import React from 'react';

import { MenuLinkAction } from '../menu/MenuLinkAction.view';
import MenuToggler from '../menu-toggler';

// @ts-ignore
import MenuIcon from '../../images/icons/menu.svg';

import './style.css';

export const DatasetActionsMenu: React.FC<{
  upstreamPipeID?: string;
  datasetID: string;
  subId: string;
}> = ({ upstreamPipeID, datasetID, subId }) => {
  const menuIcon = <MenuIcon className="dataset-actions-menu" />;

  return (
    <MenuToggler label={menuIcon} labelClassName="dataset-actions-menu__toggler">
      <MenuLinkAction
        label="Create downstream pipe"
        to={`/subscription/${subId}/pipes/new?source=${datasetID}`}
      />

      {upstreamPipeID && (
        <MenuLinkAction
          label="Go to pipe"
          to={`/subscription/${subId}/pipes/pipe/${upstreamPipeID}`}
        />
      )}
    </MenuToggler>
  );
};
